/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireAnswerOption } from './CustomQuestionnaireAnswerOption';
import {
  CustomQuestionnaireAnswerOptionFromJSON,
  CustomQuestionnaireAnswerOptionFromJSONTyped,
  CustomQuestionnaireAnswerOptionToJSON,
} from './CustomQuestionnaireAnswerOption';
import type { CustomQuestionnaireQuestionRuleConditionOperatorEnum } from './CustomQuestionnaireQuestionRuleConditionOperatorEnum';
import {
  CustomQuestionnaireQuestionRuleConditionOperatorEnumFromJSON,
  CustomQuestionnaireQuestionRuleConditionOperatorEnumFromJSONTyped,
  CustomQuestionnaireQuestionRuleConditionOperatorEnumToJSON,
} from './CustomQuestionnaireQuestionRuleConditionOperatorEnum';

/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaireQuestionRuleCondition
 */
export interface CustomQuestionnaireQuestionRuleCondition {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireQuestionRuleCondition
   */
  question: number;
  /**
   *
   * @type {CustomQuestionnaireQuestionRuleConditionOperatorEnum}
   * @memberof CustomQuestionnaireQuestionRuleCondition
   */
  operator: CustomQuestionnaireQuestionRuleConditionOperatorEnum;
  /**
   *
   * @type {CustomQuestionnaireAnswerOption}
   * @memberof CustomQuestionnaireQuestionRuleCondition
   */
  value: CustomQuestionnaireAnswerOption;
}

/**
 * Check if a given object implements the CustomQuestionnaireQuestionRuleCondition interface.
 */
export function instanceOfCustomQuestionnaireQuestionRuleCondition(
  value: object,
): value is CustomQuestionnaireQuestionRuleCondition {
  if (!('question' in value) || value['question'] === undefined) return false;
  if (!('operator' in value) || value['operator'] === undefined) return false;
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireQuestionRuleConditionFromJSON(json: any): CustomQuestionnaireQuestionRuleCondition {
  return CustomQuestionnaireQuestionRuleConditionFromJSONTyped(json, false);
}

export function CustomQuestionnaireQuestionRuleConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireQuestionRuleCondition {
  if (json == null) {
    return json;
  }
  return {
    question: json['question'],
    operator: CustomQuestionnaireQuestionRuleConditionOperatorEnumFromJSON(json['operator']),
    value: CustomQuestionnaireAnswerOptionFromJSON(json['value']),
  };
}

export function CustomQuestionnaireQuestionRuleConditionToJSON(
  value?: CustomQuestionnaireQuestionRuleCondition | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    question: value['question'],
    operator: CustomQuestionnaireQuestionRuleConditionOperatorEnumToJSON(value['operator']),
    value: CustomQuestionnaireAnswerOptionToJSON(value['value']),
  };
}
